/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Cloud provider details sourced from cloud connect discovery
 * @export
 * @interface CloudDetails
 */
export interface CloudDetails {
    /**
     * Average connections in the last hour
     * @type {number}
     * @memberof CloudDetails
     */
    'averageConnectionsCount'?: number;
    /**
     * Cloud account identifier
     * @type {string}
     * @memberof CloudDetails
     */
    'cloudAccountId'?: string;
    /**
     * CPU usage percentage
     * @type {number}
     * @memberof CloudDetails
     */
    'cpuUsagePercentage'?: number;
    /**
     * Database engine description
     * @type {string}
     * @memberof CloudDetails
     */
    'dbEngine': string;
    /**
     * Database engine version
     * @type {string}
     * @memberof CloudDetails
     */
    'engineVersion'?: string;
    /**
     * Instance class/type (e.g. \"m5.xlarge\")
     * @type {string}
     * @memberof CloudDetails
     */
    'instanceClass': string;
    /**
     * Maximum connections in the past last hour
     * @type {number}
     * @memberof CloudDetails
     */
    'maxConnectionsLastHourCount'?: number;
    /**
     * Memory usage percentage
     * @type {number}
     * @memberof CloudDetails
     */
    'memoryUsagePercentage'?: number;
    /**
     * Cloud provider
     * @type {string}
     * @memberof CloudDetails
     */
    'provider': CloudDetailsProviderEnum;
    /**
     * Total queries executed in the last hour
     * @type {number}
     * @memberof CloudDetails
     */
    'queriesLastHourCount'?: number;
    /**
     * Region where the instance is deployed (e.g. \"us-east-1\")
     * @type {string}
     * @memberof CloudDetails
     */
    'region': string;
    /**
     * Storage size in gigabytes
     * @type {number}
     * @memberof CloudDetails
     */
    'storageSizeGb'?: number;
    /**
     * Storage type
     * @type {string}
     * @memberof CloudDetails
     */
    'storageType'?: string;
}

export const CloudDetailsProviderEnum = {
    CLOUD_PROVIDER_UNSPECIFIED: 'CLOUD_PROVIDER_UNSPECIFIED',
    AWS: 'AWS',
    GCP: 'GCP'
} as const;

export type CloudDetailsProviderEnum = typeof CloudDetailsProviderEnum[keyof typeof CloudDetailsProviderEnum];


